import { createLazyComponent, LazyModule } from 'owa-bundling';
var lazyModule = new LazyModule(function () {
    return System.import(
    /* webpackChunkName: "MailListEmptyState", webpackPrefetch: true */ './lazyIndex');
});
// Delay loaded components
export var MailListEmptyState = createLazyComponent(lazyModule, function (m) { return m.MailListEmptyState; });
//# sourceMappingURL=index.js.map